// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"3b023f7a","442":"ca2d08a8","453":"a5d3b9ee","688":"40db82b2"}[chunkId] + ".chunk.js";
};